import { render, staticRenderFns } from "./publicReporter.vue?vue&type=template&id=84727a4a&scoped=true"
import script from "./publicReporter.vue?vue&type=script&lang=ts"
export * from "./publicReporter.vue?vue&type=script&lang=ts"
import style0 from "./publicReporter.vue?vue&type=style&index=0&id=84727a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84727a4a",
  null
  
)

export default component.exports